import React, { useEffect, useState } from "react";
import { fetchUsers } from "../../services/api/AdminService";
import UsersTable from "./UsersTable";
import PageLayout from "../PageLayout";
import PageUnauthorized from "../../pages/Unauthorized/Unauthorized";

function Admin({ user }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (user.is_admin) {
      fetchUsers()
        .then((res) => setUsers(res))
        .finally(() => setLoading(false));
    }
  }, []);

  if (!user.is_admin) {
    return <PageUnauthorized />;
  }

  return (
    <PageLayout>
      <div className="pl-2 lg:pl-0 pr-4">
        <div className="lg:mt-10 mb-8">
          <h1 className="text-2xl font-bold">Team members</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Manage who has access to this workspace and their roles.
          </p>
        </div>
        {loading ? (
          <div className="flex items-center justify-center py-20 text-muted-foreground text-sm">
            Loading...
          </div>
        ) : (
          <UsersTable
            users={users}
            onUsersChange={(new_users) => setUsers(new_users)}
          />
        )}
      </div>
    </PageLayout>
  );
}

export default Admin;
